import type { BasicResponse } from '../get';
import { postGenericEndpoint, PostGenericEndpointParams } from './post.api';
import type { PostChangePasswordRequest } from './types';

export const postChangePassword = async ({
	data,
	lang,
	token,
}: PostGenericEndpointParams<PostChangePasswordRequest>): Promise<BasicResponse> => {
	return await postGenericEndpoint({
		data,
		lang,
		token,
		path: 'change-password',
	});
};
